import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { VehicleLocation } from '@polaris-customerweb/sharedcomponents.garage';
import {
    Adventure,
    Dealer,
    Place,
    RideArea,
} from '@polaris-customerweb/sharedcomponents.map';
import { LocaleNumberCoordinateFormatPipe } from '@polaris-customerweb/sharedcomponents.shared';
import {
    Geofence,
    PlannedRide,
    PlannedRideViapoint,
    PlannedRideWaypoint,
    TrackedRide,
    Waypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { PlannedRideStopComponent } from 'src/app/components/common/planned-ride/planned-ride-stop/planned-ride-stop.component';
import { selectIsRidePlanning } from 'src/app/components/planned-ride/planned-ride.reducer';
import { AppState } from 'src/app/models/app-state';
import { MapPoint } from 'src/app/models/map-point';
import { RideCondition } from 'src/app/models/ride-condition';

@Component({
    imports: [
        AngularSvgIconModule,
        AsyncPipe,
        LocaleNumberCoordinateFormatPipe,
        PlannedRideStopComponent,
    ],
    selector: 'rdx-map-point-popup',
    standalone: true,
    styleUrls: ['./map-point-popup.component.scss'],
    templateUrl: './map-point-popup.component.html',
})
export class MapPointPopupComponent {
    @Input() mapPoint:
        | Adventure
        | Dealer
        | Geofence
        | Place
        | PlannedRide
        | PlannedRideWaypoint
        | PlannedRideViapoint
        | RideArea
        | RideCondition
        | TrackedRide
        | Waypoint
        | VehicleLocation;
    @Output() addMapPointToPlannedRide = new EventEmitter<MapPoint>();
    @Output() removeMapPointFromPlannedRide = new EventEmitter<{
        mapPoint: MapPoint;
        deleteSegments: boolean;
    }>();

    isRidePlanning$: Observable<boolean>;

    constructor(store: Store<AppState>) {
        this.isRidePlanning$ = store.select(selectIsRidePlanning);
    }
}
